import type { TabItemModel } from '@/api/TabsEndpoints/tabs.api';
import { createAction } from '@reduxjs/toolkit';

// Request actions handled by tabsSaga.ts. Components dispatch these instead of calling
// httpClient inline; the saga owns the API call, the optimistic store update and the rollback.
// Callbacks are for component-local concerns only (spinners, navigation) — store updates
// happen in the saga. serializableCheck is off in configureStore, so callbacks are safe here.

export interface TabCreatePayload {
  blockType: string;
  title?: string;
  icon?: string;
  onSuccess?: (tab: TabItemModel) => void;
  onDone?: () => void;
}

export interface TabDeletePayload {
  /** The tab being deleted — saga branches on custom vs predefined. */
  item: TabItemModel;
  onSuccess?: () => void;
  onDone?: () => void;
}

export interface TabRenamePayload {
  tabId: number;
  title: string;
  onDone?: () => void;
}

export interface TabTogglePayload {
  item: TabItemModel;
  isActive: boolean;
}

export interface TabsSortPayload {
  /** The full, already re-numbered design.tabs.items list. */
  items: TabItemModel[];
}

export interface PredefinedTabAddPayload {
  item: TabItemModel;
  onDone?: () => void;
}

export const tabCreateRequest = createAction<TabCreatePayload>('design/tabCreateRequest');
export const tabDeleteRequest = createAction<TabDeletePayload>('design/tabDeleteRequest');
export const tabRenameRequest = createAction<TabRenamePayload>('design/tabRenameRequest');
export const tabToggleRequest = createAction<TabTogglePayload>('design/tabToggleRequest');
export const tabsSortRequest = createAction<TabsSortPayload>('design/tabsSortRequest');
export const predefinedTabAddRequest = createAction<PredefinedTabAddPayload>('design/predefinedTabAddRequest');
